import React from 'react';

import {
  NumberInput,
  BooleanInput,
  Select,
  HtmlEditor,
  TextInput,
  TextareaInput,
  DateTimePicker,
  DatePicker,
  EmailInput,
  DeliveryDatePicker,
  ConfirmInput,
  ShowWhenContainsOtherThanH5,
  DeliveryRulesInput,
  PipeString,
  FileCropper,
  GLNInput,
  JsonInput,
  CurrencyInput,
  LabelInput,
  FileUploader,
} from 'flaivy-react/components/inputs';

// this is very hidden - sorry - I was very time limited when I write this
export default function FileUploaderWithPrefix(args) {
  return <FileUploader prefix="/private" {...args} />;
}

export {
  NumberInput,
  BooleanInput,
  Select,
  HtmlEditor,
  TextInput,
  TextareaInput,
  DateTimePicker,
  DatePicker,
  EmailInput,
  DeliveryDatePicker,
  ConfirmInput,
  ShowWhenContainsOtherThanH5,
  DeliveryRulesInput,
  PipeString,
  FileCropper,
  FileUploaderWithPrefix as FileUploader,
  GLNInput,
  JsonInput,
  CurrencyInput,
  LabelInput,
};
